import { Link } from "@tanstack/react-router";
import { m } from "@/paraglide/messages";
import { YT_VARIANT_LIST } from "../lib/variants";

const linkClass =
  "pct-panel flex items-center gap-2.5 rounded-xl px-4 py-3 text-sm font-medium transition-colors hover:border-primary/50 hover:bg-primary/[0.08]";

/** Links to the hub and keyword variants. `currentSlug` undefined on the hub. */
export function YtMoreLinks({ currentSlug }: { currentSlug?: string }) {
  const others = YT_VARIANT_LIST.filter((v) => v.slug !== currentSlug);
  return (
    <section className="mt-12">
      <h2 className="mb-4 font-display text-xl font-bold tracking-tight">
        {m.yt_more_title()}
      </h2>
      <div className="grid gap-3 sm:grid-cols-3">
        {currentSlug !== undefined && (
          <Link to="/youtube-thumbnail-downloader" className={linkClass}>
            <span aria-hidden>🖼️</span>
            <span>{m.yt_nav_main()}</span>
          </Link>
        )}
        {others.map((v) => (
          <Link
            key={v.slug}
            to="/youtube-thumbnail-downloader/$variant"
            params={{ variant: v.slug }}
            className={linkClass}
          >
            <span aria-hidden>▶️</span>
            <span>{v.navName()}</span>
          </Link>
        ))}
      </div>
    </section>
  );
}
